import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, ChevronRightIcon } from 'lucide-react';
export function ContactSection() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-942">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-943">
        <div className="mb-12" data-id="element-944">
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-945">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-946">
              <MailIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-947" />
            </div>
            <h2 className="text-2xl font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-948">
              Questions?
            </h2>
            <p className="text-base text-gray-600 mb-4" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-949">
              For additional information about the Michigan CPL Course:
            </p>
            <a href="mailto:FLSCGunTeacher@fentonlakes.com" className="inline-flex items-center gap-2 text-lg font-semibold transition-colors hover:underline" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-950">
              FLSCGunTeacher@fentonlakes.com
            </a>

            <div className="mt-6 pt-6 border-t" style={{
            borderColor: '#ede9e0'
          }} data-id="element-951">
              <p className="text-sm text-gray-500 mb-2" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-952">
                Already have your CPL?
              </p>
              <Link to="/cpl-renewal" className="inline-flex items-center gap-2 text-base font-semibold transition-colors hover:underline" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-953">
                Michigan CPL Renewal Class — Click Here for more information
                <ChevronRightIcon size={16} data-id="element-954" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
}